import { Icon, type IconName } from '@/icons/Icon'
import { useTranslation } from '@/i18n'

type ToolsRoute = 'tools/generator' | 'tools/import' | 'tools/export'

interface ToolsSubNavItem {
  route: ToolsRoute
  icon: IconName
  labelKey: string
}

const ITEMS: readonly ToolsSubNavItem[] = [
  { route: 'tools/generator', icon: 'key', labelKey: 'common.nav.tools_generator_tab' },
  { route: 'tools/import', icon: 'upload', labelKey: 'common.nav.tools_import' },
  { route: 'tools/export', icon: 'download', labelKey: 'common.nav.tools_export' },
]

export interface ToolsSubNavProps {
  active: ToolsRoute
}

export const ToolsSubNav = ({ active }: ToolsSubNavProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="tools-sub-nav" role="tablist" aria-label={t('common.nav.tools')}>
      {ITEMS.map(item => (
        <button
          key={item.route}
          type="button"
          role="tab"
          aria-selected={active === item.route}
          className={`chip${active === item.route ? ' active' : ''}`}
          onClick={() => {
            if (active === item.route) return
            window.location.hash = item.route
          }}
          data-testid={`tools-sub-nav-${item.route.split('/')[1]}`}
        >
          <Icon name={item.icon} aria-hidden="true" />
          {t(item.labelKey)}
        </button>
      ))}
    </div>
  )
}
